export const environment = {
  production: true,
  apiBaseUrl: 'https://api2.flysas.com/',
  translationFileBaseUrl: '../../translations/sasui-onboard/onboard_',
  paxPageSuffix: '/classic/#/onboard',
  apiTimeout: 60000,
  AuthDomain : 'auth.flysas.com',
  ClientId : '43zEYDsa6r8iQxqCYTfAlnY2R4e2cRzf',
  callbackURLLocalhost : 'http://localhost:4200/onboard/',
  callbackURL : 'https://flysas.com/onboard/',
  ForgotPwdLink : 'https://flysas.com/en/forgot-password/',
  labelsUrl : 'https://flysas.com/v2/cms-www/fragment/labels/customer-profile-common/',
  registerLink : 'https://flysas.com/en/register/',
};
